import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import TableContainer from "components/Common/TableContainer";
import CustomSelect from "components/Common/custom-select";
import { fetchEmployeeDropdownAutoList, fetchTimesheetReportDropdowns, fetchTimesheetTaskStatusReport, resetTimesheetEmployeeTaskStatusReport } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import toast from "react-hot-toast";
import { exportExcelFile } from "common/ExportExcelFile";
import Loader from "common/pageLoader";

const TimesheetReportTaskStatus = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    reportDropdowns,
    reportList,
    dropdownAutoList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    reportDropdowns: state.TimesheetReportsReducer?.reportDropdowns ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    reportList: state.TimesheetReportsReducer?.reportList ?? [],

    loading: state.TimesheetReportsReducer?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.TimesheetReportsReducer?.error || state.EmployeeDetailsReducer?.error,
    success: state.TimesheetReportsReducer?.success
  }));

  const { client_list, project_list, time_tasktype, time_tasknatures, time_taskstatus } = reportDropdowns;

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    const formData = new FormData();
    formData.append("unit_id", unitId)
    dispatch(fetchTimesheetReportDropdowns(formData));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetTimesheetEmployeeTaskStatusReport());
  }, [])

  const formik = useFormik({
    initialValues: {
      project: "",
      client: "",
      taskType: "",
      taskNature: "",
      status: "",
      employee: "",
    },
    onSubmit: (values) => {
      console.log('values > ', values)
      const formData = new FormData();
      formData.append("project_id", values.project && values.project.length ? values.project.map(item => item.value).join(",") : '0');
      formData.append("client_id", values.client?.value || '0');
      formData.append("task_type_id", values.taskType?.value || '0');
      formData.append("task_nature_id", values.taskNature?.value || '0');
      formData.append("task_status_id", values.status?.value || '0');
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      formData.append("emp_id", values.employee?.value || '0');
      dispatch(fetchTimesheetTaskStatusReport(formData))
    },
  });

  const columns = [
    { Header: "S.No", Cell: ({ row }) => reportList.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Client", accessor: "client_name" },
    { Header: "Project", accessor: "project_name" },
    { Header: "Module", accessor: "module_name" },
    { Header: "Task", accessor: "task" },
    { Header: "Description", accessor: "description" },
    { Header: "Type", accessor: "task_type" },
    { Header: "Nature", accessor: "task_nature" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "created_dt" },
    { Header: "Status", accessor: "Status", },
    { Header: "Allocated Hours", accessor: "allocated_hours" },
    { Header: "Worked Hours", accessor: "worked_hours" },
    { Header: "Approved Hours", accessor: "approved_hours" },
    { Header: "Billable Hours", accessor: "billable_hours" },
    { Header: "Non-Billable Hours", accessor: "nonbillable_hours" },
    { Header: "Updated On", accessor: "updated_dt" },
  ];



  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Task Status" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Client</Label>
                  <CustomSelect
                    options={(client_list || []).map(option => ({ value: option.client_id.toString(), label: option.client_name }))}
                    name="client"
                    value={formik.values.client || null}
                    onChange={(selected) =>
                      formik.setFieldValue("client", selected)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Label>Project</Label>
                  <CustomSelect
                    isMulti
                    options={(project_list || []).map(option => ({ value: option.project_id.toString(), label: option.project_name }))}
                    name="project"
                    value={formik.values.project || null}
                    onChange={(selected) =>
                      formik.setFieldValue("project", selected)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Label>Employee</Label>
                  <CustomSelect
                    id="employee"
                    name="employee"
                    options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                    value={formik.values.employee || null}  // Store full object
                    onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                    onBlur={formik.handleBlur}
                    className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                  />
                  {formik.touched.employee && formik.errors.employee && (
                    <div className="text-danger">{formik.errors.employee}</div>
                  )}
                </Col>
                <Col md={3}>
                  <Label>Task Type</Label>
                  <CustomSelect
                    options={(time_tasktype || []).map(option => ({ value: option.tasktype_id.toString(), label: option.task_type }))}
                    name="taskType"
                    value={formik.values.taskType || null}
                    onChange={(selected) =>
                      formik.setFieldValue("taskType", selected)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Label>Task Nature</Label>
                  <CustomSelect
                    options={(time_tasknatures || []).map(option => ({ value: option.task_nature_id.toString(), label: option.task_nature }))}
                    name="taskNature"
                    value={formik.values.taskNature || null}
                    onChange={(selected) =>
                      formik.setFieldValue("taskNature", selected)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Label>Status</Label>
                  <CustomSelect
                    options={(time_taskstatus || []).map(option => ({ value: option.status_id.toString(), label: option.status_name }))}
                    name="status"
                    value={formik.values.status || null}
                    onChange={(selected) =>
                      formik.setFieldValue("status", selected)
                    }
                  />
                </Col>
                <Col className="d-flex align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                    <DropdownToggle color="primary" className="btn button-export me-2">
                      <i className="fas fa-file-export me-1" /> Export
                    </DropdownToggle>

                    <DropdownMenu>
                      <DropdownItem onClick={() => exportEmployeeToExcel(reportList, authDetails?.unit_fullname || "Company Name", { address: authDetails?.unit_address || "Company Address" }, "Task Status Report")}>
                        <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                      </DropdownItem>

                      <DropdownItem onClick={() => exportEmployeeToPDF(reportList, authDetails?.unit_fullname || "Company Name", { address: authDetails?.unit_address || "Company Address" }, "Task Status Report", columns)}>
                        <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Button type="reset" onClick={formik.handleReset} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="timesheet-table">
              <TableContainer columns={columns} data={reportList} isGlobalFilter={true} customPageSize={10} />
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimesheetReportTaskStatus;
